import { Box } from '@mui/material';
import { FC } from 'react';
import { useNavigate } from 'react-router';
import { useTranslation } from 'react-i18next';
import { Button } from '../../../lib/components/atomic/button';
import { ArrowBackwardIcon } from '../../../lib/icons';

interface HeaderProps {
  showBackButton?: boolean;
  onBackClick?: () => void;
}

export const Header: FC<HeaderProps> = ({ showBackButton = true, onBackClick }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleBackClick = () => {
    if (onBackClick) {
      onBackClick();
    } else {
      window.requestAnimationFrame(() => {
        navigate('login', { replace: true });
      });
    }
  };

  return (
    <Box sx={{ px: 5, pt: 2 }}>
      <Button
        variant="tertiary"
        onClick={handleBackClick}
        style={{ visibility: showBackButton ? 'visible' : 'hidden' }}
      >
        <ArrowBackwardIcon />
        {t('common:BACK')}
      </Button>
    </Box>
  );
};
